import { render, staticRenderFns } from "./pc-preview-share-chat.vue?vue&type=template&id=c02296d2&scoped=true"
import script from "./pc-preview-share-chat.vue?vue&type=script&lang=js"
export * from "./pc-preview-share-chat.vue?vue&type=script&lang=js"
import style0 from "./pc-preview-share-chat.vue?vue&type=style&index=0&id=c02296d2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02296d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c02296d2')) {
      api.createRecord('c02296d2', component.options)
    } else {
      api.reload('c02296d2', component.options)
    }
    module.hot.accept("./pc-preview-share-chat.vue?vue&type=template&id=c02296d2&scoped=true", function () {
      api.rerender('c02296d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/share/pc-preview-share-chat.vue"
export default component.exports